import { CmsService } from '@omnia/ui/src/lib/services/cms.service'
import type { InitialData } from './models/initialData'
import type { PagesEnum } from './models/pages'
import { navigationService } from './navigation.service'

export class CineColombiaCmsService extends CmsService<InitialData, PagesEnum> {
    // Add custom methods here
}

export const cmsService = new CineColombiaCmsService(navigationService)
